<template>
  <div class="v-toggle-button__wrapper">
    <div
      v-for="item in items"
      class="v-toggle-button__item"
      @click="e => _onClick(e, item.id)"
    >
      <img
        :src="getIcon(item.id)"
        alt="icon"
        @click="e => _onClick(e, item.id)"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// icons
import cardsIcon from "@/assets/images/card-icon.svg";
import cardsIconActive from "@/assets/images/card-icon-active.svg";
import tableIcon from "@/assets/images/table-icon.svg";
import tableIconActive from "@/assets/images/table-icon-active.svg";

export default Vue.component("VToggleButton", {
  props: {
    items: VueTypes.arrayOf(
      VueTypes.shape({
        icon: VueTypes.string,
        id: VueTypes.string
      })
    ),

    activeId: VueTypes.string
  },

  data() {
    return {
      cardsIcon,
      cardsIconActive,
      tableIcon,
      tableIconActive
    };
  },

  methods: {
    _onClick(e, id) {
      e.stopPropagation();

      this.$emit("click", id);
    },

    _getFaClass(icon) {
      return `fa fa-${icon}`;
    },

    getIcon(type) {
      return type === this.activeId
        ? this[`${type}IconActive`]
        : this[`${type}Icon`];
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-toggle-button";
.#{$ns} {
  &__wrapper {
    display: flex;
    align-items: center;
  }

  &__item {
    color: #cacaca;
    transition: all 0.15s linear;
    cursor: pointer;

    &:not(.active),
    &:not(:hover) {
      border-right-color: transparent;
    }

    &:hover,
    &.active {
      border-color: $primary-color;
      color: $primary-color;
    }

    &:first-child {
      border-radius: 2px 0 0 2px;
    }

    &:last-child {
      border-radius: 0 2px 2px 0;

      &:not(.active) {
        border-right-color: inherit;
        border-left-color: transparent;
      }
    }
  }
}
</style>
